<template>
  <ul class="nav nav-tabs profile-tab" role="tablist">
    <li class="nav-item">
      <router-link
        :to="{ name: 'rankDca' }"
        class="nav-link"
        :class="{ active: activeMenu == 'DCA' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        <!-- Change icon for mobile -->
        <i class="fas fa-chess-queen"></i>
        <span class="hidden-sm-up"> {{ $t('stocks.dca.title') }}</span>
        <span class="hidden-xs-down"> {{ $t('stocks.dca.title') }}</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'rankDividend' }"
        class="nav-link"
        :class="{ active: activeMenu == 'Dividend' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        <!-- Change icon for mobile -->
        <span><i class="far fa-money-bill-alt"></i></span>
        <span class="hidden-sm-up"> {{ $t('dividend.title') }}</span>
        <span class="hidden-xs-down"> {{ $t('dividend.title') }}</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'rankGeneral' }"
        class="nav-link"
        :class="{ active: activeMenu == 'General' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        <!-- Change icon for mobile -->
        <span><i class="fas fa-adjust"></i></span>
        <span class="hidden-sm-up"> {{ $t('stocks.general.title') }}</span>
        <span class="hidden-xs-down"> {{ $t('stocks.general.title') }}</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'rank10xIncome' }"
        class="nav-link"
        :class="{ active: activeMenu == '10xIncome' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        <!-- Change icon for mobile -->
        <span><i class="fas fa-hand-holding-usd"></i></span>
        <span class="hidden-sm-up"> {{ $t('stocks.ten_x_income.title') }}</span>
        <span class="hidden-xs-down"> {{ $t('stocks.ten_x_income.title') }}</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'rankDcf' }"
        class="nav-link"
        :class="{ active: activeMenu == 'DCF' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        <!-- Change icon for mobile -->
        <span><i class="fas fa-tag"></i></span>
        <span class="hidden-sm-up"> {{ $t('stocks.dcf.title') }}</span>
        <span class="hidden-xs-down"> {{ $t('stocks.dcf.title') }}</span>
      </router-link>
    </li>
  </ul>
</template>


<script>
export default {
  name: "RankingHeader",
  props: [
    'activeMenu'
  ],
};
</script>
